import clsx from 'clsx';
import styles from './Avatar.module.css';

type Size = 'sm' | 'md' | 'lg';

type Props = {
  src?: string | null;
  name?: string | null;
  size?: Size;
  className?: string;
};

const sizeClass: Record<Size, string> = {
  sm: styles.sizeSm,
  md: styles.sizeMd,
  lg: styles.sizeLg,
};

function initials(name?: string | null): string {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function Avatar({ src, name, size = 'md', className }: Props) {
  return (
    <span className={clsx(styles.root, sizeClass[size], className)} aria-label={name ?? 'Avatar'}>
      {src ? <img className={styles.img} src={src} alt="" /> : <span>{initials(name)}</span>}
    </span>
  );
}
